/* Generated. This file cannot be edited directly. Please check codegen.ts for configuration. */
// @ts-nocheck

import * as Apollo from '@apollo/client'

import { gql } from '@apollo/client'
import * as Types from '../../../../../graphql/src/lib/graphql/generated/types'

const defaultOptions = {} as const
export type ScheduleStateChangeMutationVariables = Types.Exact<{
  input: Types.ScheduleVehicleStateChangeInput
}>

export type ScheduleStateChangeMutation = {
  __typename?: 'Mutation'
  scheduleVehicleStateChange: {
    __typename?: 'ScheduleVehicleStateChangeResponse'
    scheduledVehicleStateChange: {
      __typename?: 'ScheduledVehicleStateChange'
      id: string
      scheduledAt: string
      updatedAt: string
      vehicleStateChange: {
        __typename?: 'VehicleStateChange'
        changeReasonFreeText: string | null
        vehicleStateChangeReason: Types.VehicleStateChangeReason | null
        expectedActivationAt: string | null
      }
    }
  }
}

export const ScheduleStateChangeDocument = gql`
    mutation scheduleStateChange($input: ScheduleVehicleStateChangeInput!) {
  scheduleVehicleStateChange(input: $input) {
    scheduledVehicleStateChange {
      id
      vehicleStateChange {
        changeReasonFreeText
        vehicleStateChangeReason
        expectedActivationAt
      }
      scheduledAt
      updatedAt
    }
  }
}
    `
export type ScheduleStateChangeMutationFn = Apollo.MutationFunction<
  ScheduleStateChangeMutation,
  ScheduleStateChangeMutationVariables
>

/**
 * __useScheduleStateChangeMutation__
 *
 * To run a mutation, you first call `useScheduleStateChangeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleStateChangeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleStateChangeMutation, { data, loading, error }] = useScheduleStateChangeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleStateChangeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ScheduleStateChangeMutation,
    ScheduleStateChangeMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<
    ScheduleStateChangeMutation,
    ScheduleStateChangeMutationVariables
  >(ScheduleStateChangeDocument, options)
}
export type ScheduleStateChangeMutationHookResult = ReturnType<
  typeof useScheduleStateChangeMutation
>
export type ScheduleStateChangeMutationResult =
  Apollo.MutationResult<ScheduleStateChangeMutation>
export type ScheduleStateChangeMutationOptions = Apollo.BaseMutationOptions<
  ScheduleStateChangeMutation,
  ScheduleStateChangeMutationVariables
>
